import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Grid } from "@mui/material";

import rmsActions from "../../../../actions/rmsActions";
import { getNotes, getRmsAppCode, isFetching } from "../../../../reducers";
import { DataTypes } from "../../../../constants";
import Fetching from "../../../Common/Fetching";
import ConfirmDialog from "../../../Common/Dialog/ConfirmDialog";
import FabButton from "../../../Common/Button/FabButton";
import NoteForm from "./NoteForm";
import NoteCard from "./NoteCard";
import BreadcrumbBuilder from "../BreadcrumbBuilder";

const NotesList = () => {
    const dispatch = useDispatch();
    const [openDialog, setOpenDialog] = useState(null);
    const [selectedNote, setSelectedNote] = useState(null);

    const notes = useSelector(getNotes);
    const fetching = useSelector((state) => isFetching(state, DataTypes.NOTES));
    const appCode = useSelector(getRmsAppCode);

    useEffect(() => {
        if (!!appCode) {
            dispatch(rmsActions.getNotes(appCode));
        }
    }, [dispatch, appCode]);

    const handleOpenNoteDialog = useCallback((note = null) => {
        setSelectedNote(note);
        setOpenDialog("note");
    }, []);

    const handleOpenDeleteDialog = useCallback((note) => {
        setSelectedNote(note);
        setOpenDialog("delete");
    }, []);

    const handleCloseDialog = useCallback(() => {
        setOpenDialog(null);
        setSelectedNote(null);
    }, []);

    const onDelete = useCallback(
        (id) => {
            dispatch(rmsActions.deleteNote(id, appCode));
        },
        [dispatch, appCode]
    );

    return (
        <Container className="content">
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <BreadcrumbBuilder />
                </Grid>

                {fetching && (
                    <Grid item xs={12}>
                        <Fetching />
                    </Grid>
                )}

                {!fetching &&
                    notes?.length > 0 &&
                    notes
                        .sort((a, b) => a.title.localeCompare(b.title))
                        .map((note) => (
                            <Grid item xs={12} key={note.id}>
                                <NoteCard
                                    note={note}
                                    onEdit={() => handleOpenNoteDialog(note)}
                                    onDelete={() =>
                                        handleOpenDeleteDialog(note)
                                    }
                                />
                            </Grid>
                        ))}
            </Grid>

            <FabButton onClick={() => handleOpenNoteDialog(null)} />

            {openDialog === "delete" && !!selectedNote && (
                <ConfirmDialog
                    open={true}
                    title="Delete note"
                    content={`The following note will be deleted: ${selectedNote.title}`}
                    confirmButtonLabel="Delete"
                    onConfirm={() => onDelete(selectedNote.id)}
                    onCancel={handleCloseDialog}
                    onClose={handleCloseDialog}
                />
            )}

            {openDialog === "note" && (
                <NoteForm
                    open={true}
                    onClose={handleCloseDialog}
                    scroll="paper"
                    note={selectedNote}
                />
            )}
        </Container>
    );
};

export default NotesList;
